"use client";
import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import NextLink from "next/link";
import { useTranslation } from "react-i18next";

const SageCtaBannerSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 4, sm: 5, md: 6 },
        backgroundColor: "#FFFFFF",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            backgroundColor: "#1A1433",
            borderRadius: { xs: "16px", md: "20px" },
            px: { xs: 3, sm: 4, md: 6 },
            py: { xs: 4, md: 5 },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "center" },
            justifyContent: "space-between",
            gap: { xs: 3, md: 4 },
          }}
        >
          {/* Text */}
          <Box sx={{ textAlign: isArabic ? "right" : "left" }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "20px", sm: "22px", md: "26px" },
                fontWeight: 700,
                lineHeight: 1.3,
                color: "#FFFFFF",
                fontFamily: "var(--font-plusjakarta)",
                mb: 1,
              }}
            >
              {t("sageCtaBanner.heading")}
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "14px" },
                color: "rgba(255,255,255,0.85)",
                lineHeight: 1.6,
                fontWeight: 400,
                fontFamily: "var(--font-outfit)",
              }}
            >
              {t("sageCtaBanner.description")}
            </Typography>
          </Box>

          {/* Button */}
          <NextLink
            href="/free-trial-of-ai-recruiting-tool"
            passHref
            legacyBehavior
          >
            <Button
              component="a"
              sx={{
                bgcolor: "#FFFFFF",
                color: "#14122B",
                px: { xs: 3.5, sm: 4 },
                py: { xs: 1.2, sm: 1.4 },
                borderRadius: "50px",
                textTransform: "none",
                fontSize: { xs: "14px", sm: "15px" },
                fontWeight: 600,
                fontFamily: "var(--font-outfit)",
                whiteSpace: "nowrap",
                flexShrink: 0,
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  bgcolor: "#FFFFFF",
                  transform: "scale(1.03)",
                },
              }}
            >
              {t("sageCtaBanner.cta")}
            </Button>
          </NextLink>
        </Box>
      </Container>
    </Box>
  );
};

export default SageCtaBannerSection;